import { createReducer, on } from '@ngrx/store';

import {
    CalculateHasMoreSuccess,
    CalculateNextIndexSuccess,
    DisplayDetailOrderReset,
    DisplayDetailOrderSuccess,
    GetAddressInfoSuccess,
    GetEcoTicketUrlSuccess,
    GetInvoiceReturnSuccess,
    GetInvoiceReturnUrlSuccess,
    GetInvoiceSuccess,
    GetInvoiceUrlSuccess,
    GetShowEcoTicketSuccess, SetOrdersOnline, SetOrdersStore,
    SetOrderType,
    SetSubOrderSelected,
} from './orders-type.actions';
import { ordersTypeInitialState, OrdersTypeState } from './orders-type.state';

/**
 * Definicion de los reducers de las citas de Mi cuenta
 */
const ordersTypeReducersDefinition = createReducer(
    ordersTypeInitialState,

    on(SetOrderType, (state: OrdersTypeState, { orderType }) => {
        return { ...ordersTypeInitialState, orderType };
    }),
    on(SetOrdersOnline, (state: OrdersTypeState, { orders }) => {
        return { ...state, ordersOnline: [...state.ordersOnline || [], ...orders] };
    }),
    on(SetOrdersStore, (state: OrdersTypeState, { orders }) => {
        return { ...state, ordersStore: [...state.ordersStore || [], ...orders] };
    }),
    on(CalculateNextIndexSuccess, (state: OrdersTypeState, { nextIndex }) => {
        return { ...state, nextIndex };
    }),
    on(CalculateHasMoreSuccess, (state: OrdersTypeState, { hasMore }) => {
        return { ...state, hasMore };
    }),
    on(DisplayDetailOrderSuccess, (state: OrdersTypeState, { order }) => {
        return {
            ...state,
            detailDisplayed: {
                value: order,
            },
        };
    }),
    on(SetSubOrderSelected, (state: OrdersTypeState, { subOrderSelected }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                subOrderSelected,
            },
        };
    }),
    on(DisplayDetailOrderReset, (state: OrdersTypeState) => {
        return {
            ...state,
            detailDisplayed: {
                ...ordersTypeInitialState.detailDisplayed,
            },
        };
    }),
    on(GetAddressInfoSuccess, (state: OrdersTypeState, { address }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                shippingAddress: address,
            },
        };
    }),
    on(GetInvoiceSuccess, (state: OrdersTypeState, { invoice }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                invoiceInfo: invoice,
            },
        };
    }),
    on(GetInvoiceReturnSuccess, (state: OrdersTypeState, { invoice }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                invoiceReturnInfo: invoice,
            },
        };
    }),
    on(GetShowEcoTicketSuccess, (state: OrdersTypeState, { showEcoTicket }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                showEcoTicket,
            },
        };
    }),
    on(GetEcoTicketUrlSuccess, (state: OrdersTypeState, { ecoTicketUrl }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                ecoTicketUrl,
            },
        };
    }),
    on(GetInvoiceUrlSuccess, (state: OrdersTypeState, { invoiceUrl }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                invoiceUrl,
            },
        };
    }),
    on(GetInvoiceReturnUrlSuccess, (state: OrdersTypeState, { invoiceReturnUrl }) => {
        return {
            ...state,
            detailDisplayed: {
                ...state.detailDisplayed,
                invoiceReturnUrl,
            },
        };
    }),
);

export function ordersTypeReducers(state: OrdersTypeState, action: Action): OrdersTypeState {
    return ordersTypeReducersDefinition(state, action);
}
